import { render, staticRenderFns } from "./InfiniteScrollList.vue?vue&type=template&id=d738a3f0&scoped=true"
import script from "./InfiniteScrollList.vue?vue&type=script&lang=js"
export * from "./InfiniteScrollList.vue?vue&type=script&lang=js"
import style0 from "./InfiniteScrollList.vue?vue&type=style&index=0&id=d738a3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d738a3f0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/Users/daiyu/Desktop/work-code/bantervideo/components/Loading/index.vue').default})
